import React from 'react';
import { ProductGroupingItem } from '../../../models/ProductGroupingItem';

interface ICardProductGroupTableDataProps {
  item?: ProductGroupingItem;
}

const CardProductGroupTableData: React.FC<ICardProductGroupTableDataProps> = ({
  item
}) => {

  if (!item) return null;

  return (
    <tr>
      <td>{item.orderItem?.sku}</td>
      <td>{item.orderItem?.name}</td>
      <td>{item.orderItemId}</td>
    </tr>
  );

}

export { CardProductGroupTableData };